<template>
    <v-row justify="center">
      <v-dialog
        attach
        overlay-opacity="0.8"
        overlay-color="white"
        v-model="isShow"
        max-width="272"
        content-class="rating-dialog"
      >
        <v-card
          class="mx-auto pa-3 rating-dialog"
          v-if="!submitted"
        >
            <v-card-title class="text-h3 justify-center text-center custom-base-color rating-text">
                {{ GetCaption("RATING") }}
            </v-card-title>
            <v-card-text class="rating-card-wrapper">
                <v-rating
                    class="d-flex justify-space-around rating-icon"
                    v-model="rating"
                    length="5"
                    background-color="#ECECEC"
                    color="#F2C94C"
                    :empty-icon="mdiStar"
                    hover
                    size="45"
                ></v-rating>
                <div class="d-flex justify-space-between" v-if="rating === 0">
                    <div class="rating-info">Very Bad</div>
                    <div class="rating-info">Very Good</div>
                </div>
            </v-card-text>
            <v-expand-transition>
                <v-row class="mx-auto custom-v-row" v-show="rating">
                    <v-textarea
                        class="text-h6 rounded-lg rating-card-input"
                        v-model="notes"
                        :placeholder="GetCaption('FEEDBACK_TEXTAREA')"
                        outlined
                        solo
                        rows="4"
                        @keydown="validateInput"
                    />
                    <v-btn
                        class="white--text text-h5 rounded-lg my-2 font-weight-bold custom-submit-button"
                        width="100%"
                        color="var(--v-primary-base)"
                        @click="handleSubmit"
                    >
                        Submit
                    </v-btn>
                    <div class="text-overline mx-auto mt-1 mb-4 my-2 text-center custom-base-color">
                      Tap anywhere to dismiss
                    </div>
                </v-row>
            </v-expand-transition>
        </v-card>
        <v-card
          class="mx-auto rating-dialog justify-center"
          v-else
        >
            <v-card-title class="text-h3 justify-center text-center custom-base-color">
                {{ GetCaption("FEEDBACK_SUBMITTED") }}
            </v-card-title>
            <v-card-text class="text-center">
                {{ GetCaption("FEEDBACK_SUBMITTED_DESC") }}
            </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<style lang="scss" scoped>
.custom-base-color {
  color: var(--v-primary-base);
}
.rating-info {
  font-size: 10px;
  color: var(--v-primary-base);
}
.rating-dialog.v-dialog {
  background: #FFFFFF;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.rating-dialog.v-dialog > .v-card > .rating-card-wrapper {
  padding: 0 10px 20px !important;
}
.custom-v-row {
  max-width: 225px;
  max-height: 225px;
}
textarea::placeholder {
  font-size: 11px !important;
}
.rating-card-input.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.rating-card-input.v-textarea textarea {
  line-height: 1rem !important;
}
.rating-icon.v-rating .v-icon {
  padding: 0 !important;
}
.v-application .v-overlay {
  z-index: 201 !important;
}
.rating-text {
  inline-size: 240px;
  overflow-wrap: break-word;
}
@media #{map-get($display-breakpoints, "sm-and-up")} {
  .v-application .text-h3 {
    font-size: 16px !important;
  }
}
</style>

<script lang="ts">
import Vue from 'vue'
import { mapGetters } from 'vuex'
import { mdiStar } from '@mdi/js'

import { GetCaption } from '@/utils/util.language'
import DOMPurify from 'dompurify'

export default Vue.extend({
  name: 'Rating',

  data() {
    return {
        mdiStar,
        submitted: false,
        isShow: false,
        rating: 0,
        notes: '',
        GetCaption
    }
  },

  methods: {
    handleSubmit() {
      this.submitted = true
      setTimeout(async () => {
          const notes = DOMPurify.sanitize(this.notes)
          await this.$store.dispatch('submitRating', { rating: this.rating, notes: notes })
          this.rating = 0
          this.notes = ''
          this.submitted = false
      }, 3000)
    },
    validateInput(evt: KeyboardEvent) {
      const expect = evt.key.toString()

      if (/['"=;<>{}[]]*/.test(expect) && expect !== 'Backspace' && expect !== ' ') {
        evt.preventDefault()
      } else {
        return true
      }
    }
  },

  computed: mapGetters(['getShowRating']),

  watch: {
    getShowRating: {
      handler(newValue) {
        if (newValue === true) this.notes = ''
        this.isShow = newValue
      },
      immediate: true,
    },
  },
})
</script>
